import dev from './dev'

let config = {
  api: process.env.INTERFACE_API,
  apiM: process.env.WE_INTERFACE_API,
  apiWe: process.env.WE_INTERFACE_API,
  siteUrl: process.env.WE_URL,
  adminCenterUrl: process.env.ADMIN_CENTER_URL,
  wetagcolorlist: [
    '#E60012',
    '#000000',
    '#AD0711',
    '#00FF00',
    '#E96463',
    '#61619E',
    '#F39800',
    '#58B4AB',
    '#FF00FF',
    '#C0C0C0'
  ],
  categories: [
    'TT',
    'CW',
    'ST',
    'CE'
  ],
  areas: [
    {
      name: '北京',
      sub: [
        ''
      ]
    },
    {
      name: '广州',
      sub: [
        ''
      ]
    },
    {
      name: '杭州',
      sub: [
        '黄湖镇青山村'
      ]
    },
    {
      name: '上海',
      sub: [
        '虹口区',
        '徐汇区',
        '静安区',
        '黄浦区',
        '长宁区'
      ]
    },
    {
      name: '南京',
      sub: [
        '浦口区',
        '玄武区',
        '鼓楼区',
        '建邺区'
      ]
    },
    {
      name: '苏州',
      sub: [
        '平江区'
      ]
    },
    {
      name: '深圳',
      sub: [
        ''
      ]
    },
    {
      name: '大理',
      sub: [
        ''
      ]
    },
    {
      name: '贵阳',
      sub: [
        ''
      ]
    },
    {
      name: '成都',
      sub: [
        ''
      ]
    },
    {
      name: '天津',
      sub: [
        ''
      ]
    },
    {
      name: '香港',
      sub: [
        ''
      ]
    }
  ],
  roles: {
    1: '领队',
    2: '主持人',
    3: '督导',
    4: '志愿者'
  },
  adminRoles: {
    10: '超级管理员',
    11: 'IT',
    13: '管理员'
  },
  tripVisableStatus: {
    1: '隐藏',
    0: '正常'
  },
  tripIsCustom: {
    1: '定制团',
    0: '非定制'
  },
  tripIsYouth: {
    1: '青春路线',
    0: ''
  },
  tripLeaderRole: {
    'GIVER': '领队',
    'VOLUNTEER': '志愿者'
  },
  routeVisableStatus: {
    2: '隐藏',
    1: '正常'
  },
  tripStatus: {
    1: '在售',
    2: '取消',
    3: '下架',
    4: '结束',
    5: '正在出队',
    6: '截止报名'
  },
  tripDBStatus: {
    1: '上线团',
    2: '取消团'
  },
  stopTimeTypes: {
    1: '前一天下午5点',
    // 2: '当天中午12点',
    // 3: '当天下午3点',
    4: '活动集合时间前两小时'
  },
  givers: {
    roles: [
      'CW', 'ST', '大组长', '督导', 'CE大活动志愿者', '考官', 'ST志愿者'
    ],
    tags: [
      '2.5天',
      '禅修',
      '徒步',
      '藏文化',
      '高原',
      '骑车',
      'CW理念培训'
    ],
    statusMap: {
      '0': '实习',
      '1': '正式',
      '2': '暂停',
      '3': '机动',
      '4': '专职',
      '5': '退出'
    }
  }
}

if (process.env.NODE_ENV === 'development') {
  Object.assign(config, dev)
}

export default config



/** WEBPACK FOOTER **
 ** ./src/libs/config.js
 **/